import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import mediaQueryKeys from 'app/hooks/queries/media/mediaQueryKeys';
import { useMutation, useQueryClient } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { MediaCreateDoc } from 'types/media';

export const useCreateMedia = () => {
  const authState = useAuthSelector();
  const queryClient = useQueryClient();
  return useMutation(
    async (mediaFullDoc: MediaCreateDoc) =>
      sdk.media.mutate.create(mediaFullDoc, authState?.auth_token),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(mediaQueryKeys.all);
        await queryClient.invalidateQueries(callflowQueryKeys.all);
      },
    },
  );
};
